import type { useForm } from "hooks";
import type { Moment } from "moment";
import type { BooleanSwitch, BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    LegalNameOfBusiness = 'legalNameOfBusiness',
    TradeName = 'tradeName',
    MailingAddress = 'mailingAddress',
    EntityType = 'entityType',
    YearsUnderOwnership = 'yearsUnderOwnership',
    ProductsSold = 'productsSold',
    IncorporationId = 'incorporationId',
    CountryOfIncorporation = 'countryOfIncorporation',
    IncorporationDate = 'incorporationDate',
    CompanyAddress = 'companyAddress',
    Country = 'country',
    City = 'city',
    PostalCode = 'postalCode',
    ContactName = 'contactName',
    ContactEmail = 'contactEmail',
    ContactPhone = 'contactPhone',
    TechContactName = 'techContactName',
    TechContactEmail = 'techContactEmail',
    TechContactPhone = 'techContactPhone',
    FinContactName = 'finContactName',
    FinContactEmail = 'finContactEmail',
    FinContactPhone = 'finContactPhone',
    EmergencyContactName = 'emergencyContactName',
    EmergencyContactEmail = 'emergencyContactEmail',
    EmergencyContactPhone = 'emergencyContactPhone',
    UseContactDeatilsForTech = 'useContactDeatilsForTech',
    UseContactDeatilsForFin = 'useContactDeatilsForFin',
    UseContactDeatilsForEmergency = 'useContactDeatilsForEmergency',
    UseSinceIncorporationDate = 'useSinceIncorporationDate',
    WishDirectIntegration = 'wishDirectIntegration',
    WishDirectIntegrationInput = 'wishDirectIntegrationInput',
    IntegrationContactEmail = 'integrationContactEmail'
};

export type OnboardingBusinessInformation = {
    readonly [FormField.LegalNameOfBusiness]: string;
    readonly [FormField.TradeName]: string;
    readonly [FormField.EntityType]: string | null;
    readonly [FormField.YearsUnderOwnership]: string | number;
    readonly [FormField.ProductsSold]: string;
    readonly [FormField.IncorporationId]: string;
    readonly [FormField.CountryOfIncorporation]: string | null;
    readonly [FormField.IncorporationDate]: Moment | null;
    readonly [FormField.CompanyAddress]: string;
    readonly [FormField.MailingAddress]: string | null;
    readonly [FormField.Country]: string;
    readonly [FormField.City]: string;
    readonly [FormField.PostalCode]: string;
    readonly [FormField.ContactName]: string;
    readonly [FormField.ContactEmail]: string;
    readonly [FormField.ContactPhone]: string;
    readonly [FormField.TechContactName]: string;
    readonly [FormField.TechContactEmail]: string;
    readonly [FormField.TechContactPhone]: string;
    readonly [FormField.FinContactName]: string;
    readonly [FormField.FinContactEmail]: string;
    readonly [FormField.FinContactPhone]: string;
    readonly [FormField.EmergencyContactName]: string;
    readonly [FormField.EmergencyContactEmail]: string;
    readonly [FormField.EmergencyContactPhone]: string;
    readonly [FormField.UseContactDeatilsForTech]: boolean;
    readonly [FormField.UseContactDeatilsForFin]: boolean;
    readonly [FormField.UseContactDeatilsForEmergency]: boolean;
    readonly [FormField.UseSinceIncorporationDate]: boolean;
    readonly [FormField.WishDirectIntegration]: BooleanSwitch;
    readonly [FormField.WishDirectIntegrationInput]: string | null;
    readonly [FormField.IntegrationContactEmail]: string;
};

export type OnboardingBusinessInformationBootstrapData = {
    readonly [FormField.EntityType]: Array<string>;
};

export type OnboardingBusinessInformationForm = Omit<
    BootstrapableForm<OnboardingBusinessInformation, OnboardingBusinessInformationBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingBusinessInformation;
};

export type OnboardingBusinessInformationProps =
    & OnboardingFormProps
    & OnboardingBusinessInformationForm
    & ReturnType<typeof useForm<OnboardingBusinessInformation>>;
